import { useTranslation } from "next-i18next"

const useAccountSettingsi18n = ({ componentProps }) => {
  const { t } = useTranslation()
  const i18n = {
    accountSettings: t("kf.account.label.accountSettings"),
    accountType: t("kf.account.label.accountType"),
    accountSubType: t("kf.account.label.accountSubType"),
    editMyInfo: t("kf.account.label.editMyInfo"),
    editProfile: t("kf.account.label.editProfile"),
    email: t("kf.registration.label.email"),
    emailAddress: t("kf.registration.label.email"),
    businessEmailAddress: t("kf.registration.label.busniessEmail"),
    businessName: t("kf.registration.label.busniessName"),
    businessNameError: t("kf.auth.error.businessNameError"),
    businessType: t("kf.registration.label.busniessType"),
    businessTypeError: t("kf.auth.error.businessTypeError"),
    businessSubType: t("kf.registration.label.busniessSubType"),
    subTypeError: t("kf.auth.error.subTypeError"),
    businessZipCode: t("kf.registration.label.businessZipCode"),
    firstName: t("kf.account.label.firstName"),
    fnameError: t("kf.auth.error.fnameError"),
    lastName: t("kf.account.label.lastName"),
    lnameError: t("kf.auth.error.lnameError"),
    homePhone: t("kf.account.label.homePhone"),
    mobilePhone: t("kf.account.label.mobilePhone"),
    phone: t("kf.checkout.label.phone"),
    validPhone: t("kf.checkout.error.validPhone"),
    address: t("kf.account.label.address"),
    default: t("kf.account.label.default"),
    addresses: t("kf.account.label.addresses"),
    addAddress: t("kf.account.label.addAddress"),
    edit: t("kf.account.label.edit"),
    delete: t("kf.account.label.delete"),
    loginSecurity: t("kf.account.label.loginSecurity"),
    password: t("kf.account.label.password"),
    communicationPreferences:
      componentProps?.communicationPreferences ??
      t("kf.account.label.communicationPreferences"),
    subscribeForEmail:
      componentProps?.subscribeForEmail ??
      t("kf.account.label.subscribeForEmail"),
    communicationDesc:
      componentProps?.communicationDesc ??
      t("kf.account.label.communicationDesc"),
    subscribe: t("kf.account.label.subscribe"),
    accountManagement: t("kf.account.label.accountManagement"),
    deleteMssg: componentProps?.deleteMssg ?? t("kf.account.label.deleteMssg"),
    deleteAccount: t("kf.account.label.deleteAccount"),
    accountDeleteTitle: t("kf.account.label.accountDeleteTitle"),
    accountDeleteMssg:
      componentProps?.accountDeleteMssg ??
      t("kf.account.label.accountDeleteMssg"),
    cancel: t("kf.account.label.cancel"),
    submit: t("kf.account.label.submit"),
    save: t("kf.account.label.save"),
    accountDeleted:
      componentProps?.accountDeleted ?? t("kf.account.label.accountDeleted"),
    passwordRequirements: t("kf.auth.label.passwordRequirements"),
    pwMustInclude: t("kf.auth.label.pwMustInclude"),
    characterCount: t("kf.auth.label.characterCount"),
    uppercaseLetter: t("kf.auth.label.uppercaseLetter"),
    lowercaseLetter: t("kf.auth.label.lowercaseLetter"),
    symbolValidation: t("kf.auth.label.symbolValidation"),
    numberValidation: t("kf.auth.label.numberValidation"),
    passwordError: t("kf.auth.error.passwordError"),
    passwordMatchError: t("kf.auth.error.passwordMatchError"),
    requiredFields: t("kf.auth.label.requiredFields"),
    managePassword: t("kf.account.label.managePassword"),
    enterOldPassword:
      componentProps?.enterOldPassword ??
      t("kf.account.label.enterOldPassword"),
    createPassword: t("kf.account.label.createPassword"),
    reEnterPassword: t("kf.auth.label.reEnterPassword"),
    passwordChanged: t("kf.account.label.passwordChanged"),
    verifyOldPassword:
      componentProps?.verifyOldPassword ??
      t("kf.account.error.verifyOldPassword"),
    recentPassword: t("kf.account.error.recentPassword"),
    differentFromOld: t("kf.account.error.differentFromOld"),
    editAddress: t("kf.account.label.editAddress"),
    aptFloorSuite: t("kf.account.label.aptFloorSuite"),
    state: t("kf.account.label.state"),
    city: t("kf.account.label.city"),
    zipcode: t("kf.account.label.zipcode"),
    setDefaultLabel: t("kf.account.label.setDefaultLabel"),
    remove: t("kf.account.label.remove"),
    primaryAddress: t("kf.account.label.primaryAddress"),
    addressError: t("kf.account.error.addressError"),
    aptFloorSuiteError: t("kf.account.error.aptFloorSuiteError"),
    cityError: t("kf.account.error.cityError"),
    stateError: t("kf.account.error.stateError"),
    zipCodeError: t("kf.auth.error.zipcodeError"),
    zipCodeMinError: t("kf.account.error.zipCodeMinError"),
    validZipcode: t("kf.auth.error.validZipcode"),
    addressTypesError: t("kf.account.error.addressTypesError"),
    addAnotherAddress: t("kf.account.label.addAnotherAddress"),
    deleteAddress: t("kf.account.aria.deleteAddress"),
    editLogin: t("kf.account.aria.editLogin"),
    validFirstName: t("kf.auth.error.validFirstName"),
    validLastName: t("kf.auth.error.validLastName"),
    noSave: t("kf.account.label.noSave"),
    yesDelete: t("kf.account.label.yesDelete"),
    // new
    newToOld: t("kf.myProducts.sort.newToOld"),
    oldToNew: t("kf.myProducts.sort.oldToNew"),
    AToZ: t("kf.services.sort.AToZ"),
    ZToA: t("kf.services.sort.ZToA"),
    myServices: t("kf.services.label.myServices"),
    sort: t("kf.services.label.sortBy"),
    sortbyExpanded: t("kf.plp.label.sortbyExpanded"),
    sortbyClosed: t("kf.plp.label.sortbyClosed"),
    selected: t("kf.plp.arialabel.selected"),
    altSort: t("kf.plp.label.img.altSort"),
    activeServices: t("kf.services.label.activeServices"),
    noServices: t("kf.services.label.noServices"),
    continueShopping: t("kf.services.label.continueShopping"),
    pastServices: t("kf.services.label.pastServices"),
    sortByAria: count => t("kf.plp.label.sortByAria", { sortByCount: count }),
    hi: t("kf.account.label.hi"),
    signOut: t("kf.account.label.signOut"),
    myAccount: t("kf.account.label.myAccount"),
    favorites: t("kf.account.label.favorites"),
    orders: t("kf.account.label.orders"),
    myProducts: t("kf.account.label.myProducts"),
    myServices: t("kf.account.label.myServices"),
    profileUpdated: t("kf.account.label.profileUpdated"),
    addAddressMessage: t("kf.account.label.addAddrress"),
    editAddressMessage: t("kf.account.label.editAddrress"),
    deleteAddress: t("kf.account.label.deleteAddrress"),
    accountProfile: t("kf.account.label.accountProfile"),
    name: t("kf.account.label.name"),
    professionalAccount: t("kf.auth.label.professionalAccount"),
  }

  return i18n
}

export default useAccountSettingsi18n
